<template>
  <div>
    <h2>Accounting Reports</h2>
    <div class="e-card" id="basic">
      <div class="e-card-content">
        <ejs-tab class="e-background" :selecting="select">
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0" />
            <e-tabitem :header="headerText1" :content="content1" />
            <e-tabitem :header="headerText2" :content="content2" />
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
    <div id="accountingReports">
      <accounting-reports />
    </div>
    <div id="sageReports" style="display: none">
      <sage-reports />
    </div>
    <div id="historicalInvoiceReports" style="display: none">
      <historical-invoice-reports />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
import accountingReports from '../components/accounting-reports.vue';
import sageReports from '../components/sage-reports.vue';
import historicalInvoiceReports from '../components/historical-invoice-reports.vue';

Vue.use(TabPlugin);

export default {
  components: { accountingReports, sageReports, historicalInvoiceReports },
  data() {
    return {
      headerText0: { text: ' Accounting Reports ' },
      headerText1: { text: ' Sage Reports ' },
      headerText2: { text: 'Historical Invoice Reports' },
      content0: '#accountingReports',
      content1: '#sageReports',
      content2: '#historicalInvoiceReports',
    };
  },
  methods: {
    select(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
  },
};
</script>
